/* eslint-disable no-underscore-dangle */
import axios from '../../utils/axios';
import config from '../../config/index.json';
import store from '../../redux/store';
import { encode } from '../../utils/encode';
import getHeader from '../../utils/header';
import { DVA_ORDER_TYPE } from '../../constants/dvacreditclaim.const';


export const getProductList = async (postData, pageName, customPriceListId = "", shipToSiteAddressId = 0) => {
  const { setUser, cartDetails, authentication } = store.getState();
  const qualifier = authentication.user._accounts[0]._element.filter(a => a.AP_ACCOUNT_NUMBER === setUser.accountNumber);
  const apQualifier = qualifier[0]?.AP_QUALIFIER?.replaceAll(',', '|');
  const priceListId = pageName === DVA_ORDER_TYPE  ? customPriceListId : cartDetails?.priceListId ?? "";
  const shipToSiteId = (pageName === DVA_ORDER_TYPE ? shipToSiteAddressId : cartDetails?.shipToSiteAddressID) || 0;

  let type;
  switch (pageName) {
    case 'search':
      type = cartDetails.orderType;
      break;
    case 'maskGuarantee':
      type = 'MASKGUARANTEE';
      break;
    case 'maskGuaranteeLegacy':
      type = 'MASKGUARANTEELEGACY';
      break;
    case 'returns':
      type = 'RETURNS';
      break;
    case 'AU_DVA':
      type = 'AU_DVA';
      break;
    default:
      type = '';
  }

  const headerParams = {
    headers: getHeader({ functionName: 'searchProduct.getProductList', values: [setUser.accountNumber, pageName ? `ORDER_TYPE=${type},GEOIP_ZIP_OR_POST_CODE=ROS,GEOIP_FIRST_LEVEL_DOMAIN=${type},GEOIP_SECOND_LEVEL_DOMAIN=${shipToSiteId},CUSTOMER_SEGMENT=${apQualifier},PRICE_LIST_ID=${priceListId}` : ''] }),
  };
  try {
    const resp = await axios.post(`${config.api.path}/searches/${localStorage.getItem('StoreName')}/keywords/form?followlocation&zoom=element:definition,element:code,element:price`, postData, headerParams);
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export const getAssociatedCompanyName = async (data) => {
  const { setUser } = store.getState();
  const acountId = Number.isNaN(Number(data?.keywords)) ? `ACCOUNT_NAME=${data.keywords}` : `ACCOUNT_NUMBER=${data.keywords}`;
  // const pageNo = pageNumber + 1 || 1;
  // const rowPPage = rowPerPage || 5;
  const headerParams = {
    headers: getHeader({ functionName: 'searchProduct.getAssociatedCompanyName', values: [setUser.accountNumber] }),
  };
  try {
    const resp = await axios.get(`${config.api.path}/accountdetails/${localStorage.getItem('StoreName')}/account/${encode(acountId)}/1/100`, headerParams);
    return resp;
  } catch (err) {
    throw err.message;
  }
};

export default {
  getProductList,
  getAssociatedCompanyName,
};
